module.exports = __webpack_public_path__ + "img/02.ed0846b2.jpg";